import React from 'react'

import './styles.scss'

const GraphLoader = () => (
  <div className="loader graph-loader">
    <div className="graph-loader__graph">
      <div
        className="loader-row"
        style={{
          width: 12,
          height: 130,
          position: 'absolute',
          bottom: 75,
          left: -22,
        }}
      />
      <div
        style={{
          width: 150,
          height: 2,
          position: 'absolute',
          overflow: 'hidden',
          bottom: 40,
          transformOrigin: '0 50%',
          transform: 'rotate(-15deg)',
        }}
      >
        <div
          className="loader-row"
          style={{
            width: 350,
            height: 400,
            top: -400,
            left: 0,
            transform: 'rotate(35deg) translate(0, -390px)',
            transformOrigin: '0 0',
          }}
        />
      </div>
      <div
        className="loader-row"
        style={{
          width: 86,
          height: 2,
          bottom: 79,
          left: 145,
          position: 'absolute',
        }}
      />
      <div
        style={{
          width: 127,
          height: 2,
          position: 'absolute',
          overflow: 'hidden',
          left: 230,
          bottom: 79,
          transformOrigin: '0 50%',
          transform: 'rotate(-15deg)',
        }}
      >
        <div
          className="loader-row"
          style={{
            width: 350,
            height: 400,
            top: -400,
            left: 0,
            transform: 'rotate(35deg) translate(0, -390px)',
            transformOrigin: '0 0',
          }}
        />
      </div>
    </div>
    <div className="graph-loader__x">
      <div
        className="loader-row"
        style={{
          width: 22,
          height: 8,
        }}
      />
      <div
        className="loader-row"
        style={{
          width: 22,
          height: 8,
        }}
      />
      <div
        className="loader-row"
        style={{
          width: 22,
          height: 8,
        }}
      />
      <div
        className="loader-row"
        style={{
          width: 22,
          height: 8,
        }}
      />
      <div
        className="loader-row"
        style={{
          width: 22,
          height: 8,
        }}
      />
      <div
        className="loader-row"
        style={{
          width: 22,
          height: 8,
        }}
      />
      <div
        className="loader-row"
        style={{
          width: 22,
          height: 8,
        }}
      />
      <div
        className="loader-row"
        style={{
          flexGrow: 2,
          height: 8,
        }}
      />
    </div>
  </div>
)

GraphLoader.displayName = 'GraphLoader'

export default GraphLoader
